export default __webpack_public_path__ + "static/media/pic2.67db6c47.jpg";